

import { Modal, Table, Tag } from 'antd'
import moment from 'moment'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'



export default function ProductionDetailed({
	visible,
	data = {},
	onClose,
	service,
}) {
	const [timer, setTimer] = useState({})
	const { t } = useTranslation()

	useEffect(() => {
		if (data) {
			console.log('data', data)
			const newTimer = {}
			let remainingTime = null
			const currentTime = moment()
			data?.documentLines?.forEach((item) => {
				const startTime = moment(item.startTime, 'HH:mm:ss')
				const elapsedSeconds = currentTime.diff(startTime, 'seconds')
				remainingTime = Number(item.u_Timer) * 60 - elapsedSeconds

				newTimer[`${item.serialNumber}-${service}`] = {
					startTime: item.startTime,
					timer: remainingTime,
					u_Timer: item.u_Timer,
					isActive: item.isStart === 'Yes' && item.ready === 'No' && item.u_IsBroken === "N",
					status:
						item.isStart === 'Yes' && item.ready === 'No' && item.u_IsBroken === "N"
							? 'inProcess3'
							: item.ready === 'Yes' && item.u_IsBroken === "N"
								? 'completed'
								: item.u_IsBroken === "Y"
									? 'isBroken'
								: 'notStarted',

					isStart: item.isStart,
					ready: item.ready,
					wastedTime: item.wastedTime,
					width: item.width,
					height: item.height,

					serialNumber: item.serialNumber,
				}
			})
			setTimer(newTimer)
			console.log('newTimer', newTimer)
		}
	}, [data, visible, service])

	useEffect(() => {
		const interval = setInterval(() => {
			setTimer((prevTimers) => {
				const updatedTimers = {}
				Object.keys(prevTimers).forEach((key) => {
					updatedTimers[key] = {
						...prevTimers[key],
						timer: prevTimers[key].isActive
							? prevTimers[key].timer - 1
							: prevTimers[key].timer,
					}
				})
				return updatedTimers
			})
		}, 1000)

		return () => clearInterval(interval)
	}, [timer])

	const columns = [
		{
			title: t('serialNumber'),
			dataIndex: 'serialNumber',
			key: 'serialNumber',
		},
		{
			title: t('itemsName'),
			key: 'itemName',
			render: (text, record) => <span>{data?.itemName}</span>,
		},
		{
			title: t('size'),
			key: 'size',
			render: (text, record) => (
				<span>{`${record?.width || ""} x ${record?.height || ""}`}</span>
			),
		},


		{
			title: t('status'),
			dataIndex: 'status',
			key: 'status',
			render: (text) => {
				return text && text === 'inProcess3' ? (
					<Tag color="blue">{t(text)}</Tag>
				) : text === 'completed' ? (
					<Tag color="green">{t(text)}</Tag>
				) : text === "isBroken" ? (<Tag color="orange">{t(text)}</Tag>) : (
					<Tag color="yellow">{t(text)}</Tag>
				)
			},
		},
	]

	return (
		<Modal open={visible} onCancel={onClose} footer={null} width="90%">
			<p className="text-center m-5 text-xl font-bold">
				{t('service')} : {data?.serviceDescription}
			</p>
			<Table
				dataSource={Object.values(timer).sort(
					(a, b) => b.isActive - a.isActive,
				)}
				columns={columns}
				pagination={false}
			/>
		</Modal>
	)
}
